import { HTMLDisplayComponentRequestJSON } from "./../htmlComponent/HTML-Display-Component-Request.JSON";
export class QuestionDetailsHeaderRequestJSON {
    surveyID: Number;
    userName: string;
    email: String;
    companyName:String;
    mobileNumber:Number;
    hHTMLDisplayComponentList: HTMLDisplayComponentRequestJSON[];
}